module.exports = __webpack_public_path__ + "static/media/our-story-one.7e8537ff.jpg";